<template>
    <h4 class="mt-3 mb-3 text-center">Events by Month</h4>
    <div class="mb-3">
        <div class="row">
            <div class="col">
                <div class="form-floating">
                    <select class="form-select" name="month" v-on:change="getData" v-model="month">
                        <option v-for="month in months" :value="month.value">
                            {{ month.text }}
                        </option>
                    </select>
                    <label for="inputMonth">Month</label>
                </div>
            </div>
            <div class="col">
                <div class="form-floating">
                    <select class="form-select" name="year" v-on:change="getData" v-model="year">
                        <option v-for="n in lastYear-(firstYear-1)" :value="n + (firstYear - 1)">
                            {{ n + (firstYear - 1) }}
                        </option>
                    </select>
                    <label for="inputYear">Year</label>
                </div>
            </div>
        </div>
    </div>

    <div class="mb-3" v-if="events.length">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col">Date</th>
                    <th scope="col" class="text-center">Rainfall (mm)</th>
                    <th scope="col">Attributes</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="event in events">
                    <td v-if="this.eventUserId == this.authUserId"><a :href="'/event/' + event.id + '/edit'" class="text-nowrap">{{ event.date }}</a></td>
                    <td v-else>{{ event.date }}</td>
                    <td class="text-center">{{ event.rainfall }}</td>
                    <td>
                        <i class="bi-cloud-fog p-1" v-if="event.fog"></i>
                        <i class="bi-cloud-hail p-1" v-if="event.hail"></i>
                        <i class="bi-cloud-snow p-1" v-if="event.snow"></i>
                        <i class="bi-cloud-lightning p-1" v-if="event.thunder"></i>
                        <i class="bi-sun p-1" v-if="event.sun"></i>
                        <i class="bi-cloud p-1" v-if="event.cloud"></i>
                    </td>

                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th>Total</th>
                    <th class="text-center">{{ totalRainfall }}</th>
                    <th></th>
                </tr>
            </tfoot>
        </table>
    </div>

    <div class="mb-3" v-if="!events.length && showMessage">
        <p>There are no events defined for this period</p>
    </div>
</template>

<script>
export default {
    props: [
        'eventUsername',
        'eventUserId',
        'authUserId',
        'firstYear',
        'lastYear',
    ],
    data() {
        return {
            months: [
                { value: '1', text: 'January' },
                { value: '2', text: 'February' },
                { value: '3', text: 'March' },
                { value: '4', text: 'April' },
                { value: '5', text: 'May' },
                { value: '6', text: 'June' },
                { value: '7', text: 'July' },
                { value: '8', text: 'August' },
                { value: '9', text: 'September' },
                { value: '10', text: 'October' },
                { value: '11', text: 'November' },
                { value: '12', text: 'Decemeber' },
            ],
            month: 1, // January.
            year: this.lastYear, // The last year of Events the user entered.
            events: [],
            showMessage: false,
        };
    },
    computed: {
        totalRainfall: function(){
            return this.events.reduce(function(total, item) {
                return total + Number(item.rainfall);
            }, 0).toFixed(1);
        }
    },
    methods: {
        getData: function () {
            axios.get("/ajax/dash/" + this.eventUsername + "/listmonth/" + this.month + "/" + this.year)
                .then(response => {
                    this.events = response.data.data;
                    this.showMessage = true;
                })
        }
    },
    mounted() {
        this.getData();
    }
};
</script>
